<template>
  <div>
    <!--
      :model-value and @update:model-value are used instead of v-model because the ID of the category is passed,
      but the select needs an object because the select options need to show the name of the category
    -->
    <FrameworkCategorySelect
      v-for="framework in frameworks"
      :key="framework.id"
      :framework="framework"
      :model-value="getSelectedCategoriesByFramework(framework)"
      @update:model-value="handleUpdate($event, framework)"
      @show-framework-overview="$emit('show-framework-overview', $event)"
    />
  </div>
</template>

<script setup>
import { FrameworkCategorySelect } from '@/components/form-inputs';

const model = defineModel({ type: Array, default: [] });

defineProps({
  frameworks: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits(['show-framework-overview']);

const getSelectedCategoriesByFramework = framework => {
  // Get the framework-category object that corresponds with the framework that the categories were selected for
  const selectedFrameworkCategory = model.value.find(frameworkCategory => frameworkCategory.framework === framework.id);

  if (selectedFrameworkCategory) {
    // Return the category objects from the framework that the categories were selected for
    return framework.categories.filter(category => selectedFrameworkCategory.categories.includes(category.id));
  }

  return [];
};

const handleUpdate = (categories, framework) => {
  if (!categories.length) {
    const frameworkCategory = model.value.find(frameworkCategory => frameworkCategory.framework === framework.id);

    frameworkCategory.categories = [];

    return;
  }

  const frameworkCategory = { framework: categories[0].framework.id, categories: categories.map(item => item.id) };

  // Update the existing FrameworkCategory if it exists (based on the Framework ID), else insert the new FrameworkCategory
  model.value = [...model.value.filter((obj) => obj.framework !== frameworkCategory.framework), frameworkCategory];
};

</script>
